import * as Sentry from '@sentry/react';
import { nanoid } from 'nanoid/non-secure';
import { useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { STORAGE_KEY_PREFIX } from '@/utils/constants';

export default function useClientId() {
  const [clientId, setClientId] = useLocalStorage(`${STORAGE_KEY_PREFIX}/client-id`, '');

  useEffect(() => {
    if (!clientId) {
      setClientId(nanoid(12));
    } else {
      Sentry.setTag('client_id', clientId);
    }
  }, [clientId]);

  return { clientId };
}
